import { axios } from '@/api/common'
import { queryOptions } from '@tanstack/react-query'
import { Inv2215GetResultModel, Inv2215GetResultSchema } from './get.schema'

export async function fetchInv2215(id: number): Promise<Inv2215GetResultModel> {
  const response = await axios.get<Inv2215GetResultModel>(
    `/api/warehouse/inv2215/${id}`
  )
  console.log('fetchInv2215', response.data)
  return Inv2215GetResultSchema.parse(response.data)
}

export const getInv2215ByIdOptions = (id: number) =>
  queryOptions({
    queryKey: ['inv2215', id],
    queryFn: () => fetchInv2215(id),
  })
